export const ageMethod = "age nearest";
export const gateway = "https://hwi-api.link.wawanesalife.com";
export const assets = "https://stable-assets.link.wawanesalife.com/brokers/hwi";
export const googleApiKey = "AIzaSyD8GAXLH7FxUmF13tfHgXVAU6fWk66UH3k";
export const appToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJod2kiLCJuYW1lIjoiaHdpIiwiaWF0IjoxNzc5OTIwOTMxLCJleHAiOjE5Mzc3MDg5MzF9.IPJrOymas7qANIF_jagBzdb3Kjixmkt3joyrsC66XPA";
export const brokerConfig = {
	enabled: "yes",
	"split": '0.6'
};
export const brokerBranding = {
	"hwi.link.wawanesalife.com": {
		a: {
			approve_company: "CENTRAL",
			approve_user: "link_hwi",
			brands: [
				"hwi.link.wawanesalife.com",
			],
			broker: "hwi",
			broker_formatted_name: "Harvard Western Insurance",
			email: "info@harvardwestern.com",
			environment: "stable",
			environment_id: "stable",
			faq_text: "Frequently Asked Questions",
			g4: "GTM-P6HT43K",
			layout: "modern",
			logoPosition: "menu",
			"maps": {
				"map3": [
					"4420 Albert Street",
					"Regina",
					"SK",
					"S4S 6B4",
				],
				"map2": [
					"464 McCarthy Blvd. N.",
					"Regina",
					"SK",
					"S4R 7M2",
				],
				"map1": [
					"3615 Quance Street East",
					"Regina",
					"SK",
					"S4V 3A4",
				],
				"map10": [
					"115 3rd St",
					"Dalmeny",
					"SK",
					"S0K 1E0",
				],
				"map7": [
					"109 Souris Street",
					"Yellow Grass",
					"SK",
					"S0G 5J0",
				],
				"map6": [
					"128 Main Street",
					"Milestone",
					"SK",
					"S0G 3L0",
				],
				"map5": [
					"5 Main Street",
					"Kronau",
					"SK",
					"S0G 2T0",
				],
				"map4": [
					"407 Broad Street",
					"Regina",
					"SK",
					"S4R 1X4",
				],
				"map9": [
					"133 Main Street",
					"Rouleau",
					"SK",
					"S0G 4H0",
				],
				"map8": [
					"200 Mergens Street",
					"Pangman",
					"SK",
					"S0C 2C0",
				],
			},
			menuPhone: "button",
			phone: "1-306-757-1633",
			privacyLink: "https://harvardwestern.com/privacy-policy/",
			render_fake_email_button: "yes",
			website: "https://harvardwestern.com/",
			scope: "hwi#branding#hwi.link.wawanesalife.com#a",
			ab: "a",
			logo: "a.png",
			brand_name: "hwi.link.wawanesalife.com",
		},
		b: {
			approve_company: "CENTRAL",
			approve_user: "link_hwi",
			brands: [
				"hwi.link.wawanesalife.com",
			],
			broker: "hwi",
			broker_formatted_name: "Harvard Western Insurance",
			email: "info@harvardwestern.com",
			environment: "stable",
			environment_id: "stable",
			faq_text: "Frequently Asked Questions",
			g4: "GTM-P6HT43K",
			layout: "modern",
			logoPosition: "menu",
			"maps": {
				"map3": [
					"4420 Albert Street",
					"Regina",
					"SK",
					"S4S 6B4",
				],
				"map2": [
					"464 McCarthy Blvd. N.",
					"Regina",
					"SK",
					"S4R 7M2",
				],
				"map1": [
					"3615 Quance Street East",
					"Regina",
					"SK",
					"S4V 3A4",
				],
				"map10": [
					"115 3rd St",
					"Dalmeny",
					"SK",
					"S0K 1E0",
				],
				"map7": [
					"109 Souris Street",
					"Yellow Grass",
					"SK",
					"S0G 5J0",
				],
				"map6": [
					"128 Main Street",
					"Milestone",
					"SK",
					"S0G 3L0",
				],
				"map5": [
					"5 Main Street",
					"Kronau",
					"SK",
					"S0G 2T0",
				],
				"map4": [
					"407 Broad Street",
					"Regina",
					"SK",
					"S4R 1X4",
				],
				"map9": [
					"133 Main Street",
					"Rouleau",
					"SK",
					"S0G 4H0",
				],
				"map8": [
					"200 Mergens Street",
					"Pangman",
					"SK",
					"S0C 2C0",
				],
			},
			menuPhone: "button",
			phone: "1-306-757-1633",
			privacyLink: "https://harvardwestern.com/privacy-policy/",
			render_fake_email_button: "yes",
			website: "https://harvardwestern.com/",
			scope: "hwi#branding#hwi.link.wawanesalife.com#b",
			ab: "b",
			logo: "b.png",
			brand_name: "hwi.link.wawanesalife.com",
		},
	},
};

//updated on Wed May 27 2026 17:28:51 GMT-0500 (Central Daylight Time)
